import styled from "styled-components"
export const FooterContainer = styled.footer`
  padding: ${({ padding }) => padding || '60px 0px'};
  display: flex;
  justify-content: space-between;
  align-items: center;
  row-gap: 20px;
  // height: 84px;
  background:${({ theme }) => theme.app.background};
  width:100%;
  z-index: 40;
`;

export const LogoSection = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  column-gap: 8px;
  margin-right: 20px;
  height: 36px;

  .company-text {
    white-space: normal;
    display: inline-block;
    font-family: 'Poppins', sans-serif;
    font-style: normal;
    letter-spacing: 0px;
    text-align: left;
  }


  .social {
    margin-top: 25px;
    display: flex;
    gap: 20px;

    svg {
      font-size: 22px;
      cursor: pointer;
      transition: 0.3s;

      &:hover {
        opacity: 0.7;
      }
    }
  }
`;

export const FooterGrid = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  text-align: left;
  gap: 40px;
  margin-right: 40px;
`;

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  row-gap: 10px;
  column-gap: 20px;
  margin-right: 20px;

  a,
  .footer-link {
    color: ${({ theme }) => theme.app.iconlabel};
    font-size: 14px;
    text-decoration: none;
    font-weight: 400;
    cursor: pointer;
  }

  .footer-link {
    background: none;
    border: none;
    padding: 0;
  }
`;


export const Column = styled.div`
  display: flex;
  max-width: 170px;
  flex-direction: column;

  display: block;
  color: ${({ theme }) => theme.app.iconlabel};
  font-size: 14px;
  text-decoration: none;
  font-weight: 400;
`;


export const LanguageWrapper = styled.div`
      position: relative;
    `;

export const LanguageSelector = styled.div`
      display: flex;
      align-items: center;
      gap: 6px;
      cursor: pointer;
      user-select: none;
    
      color: ${({ theme }) => theme.app.iconlabel};
    
      svg {
        font-size: 14px;
        transition: transform 0.2s ease;
      }
    
      .rotate {
        transform: rotate(180deg);
      }
    
      span {
        font-size: 14px;
        font-weight: 400;
      }
    `;

export const LanguageDropdown = styled.div`
      position: absolute;
      bottom: 120%;
      left: 0;
    
      background: ${({ theme }) => theme.app.dashboardCardsBG};
      border-radius: 6px;
      min-width: 120px;
      padding: 6px 0;
      text-align: left;
      z-index: 99;
    
      div {
        padding: 8px 12px;
        font-size: 14px;
        cursor: pointer;
        color: ${({ theme }) => theme.app.iconlabel};
    
        &:hover {
          background: ${({ theme }) => theme.app.dashboardBG};
        }
      }
    `;


export const MobileFooterContainer = styled.footer`
    padding: ${({ padding }) => padding || '24px 24px'};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    height: ${({ height }) => height || 'auto'};
    text-align: left;
  margin-bottom: 0;
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  background: #000;
  z-index: 40;
  `;

export const MobileLogoSection = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;

    .company-text {
      white-space: normal;
      display: inline-block;
      font-family: 'Poppins', sans-serif;
      font-style: normal;
      letter-spacing: 0px;
      text-align: left;
    }
  `;

export const MobileLinksContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 24px;
    width: 100%;
    justify-content: space-between;

    a,
    .footer-link {
      color: ${({ theme }) => theme.app.iconlabel};
      font-size: 12px;
      text-decoration: none;
      font-weight: 400;
      cursor: pointer;
      display: block;
    }

    .footer-link {
      background: none;
      border: none;
      padding: 0;
    }
  `;

export const MobileLanguageWrapper = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: flex-start;
  `;

export const MobileLanguageSelector = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    user-select: none;
    color: ${({ theme }) => theme.app.iconlabel};

    svg {
      font-size: 14px;
      transition: transform 0.2s ease;
    }

    .rotate {
      transform: rotate(180deg);
    }

    span {
      font-size: 12px;
      font-weight: 400;
    }
  `;

export const MobileLanguageDropdown = styled.div`
    position: absolute;
    bottom: 120%;
    left: 0;

    background: ${({ theme }) => theme.app.dashboardCardsBG};
    border-radius: 6px;
    min-width: 140px;
    padding: 6px 0;
    z-index: 10;

    div {
      padding: 8px 12px;
      font-size: 14px;
      cursor: pointer;
      color: ${({ theme }) => theme.app.iconlabel};

      &:hover {
        background: ${({ theme }) => theme.app.dashboardBG};
      }
    }
  `;
